import { isOnServer } from '@whitelabel/helpers/utils';

export const PUBLIC_URL =
  process.env.REACT_APP_PUBLIC_URL || process.env.NEXT_PUBLIC_PUBLIC_URL || (isOnServer ? '' : window.location.origin);
export const PROTOCOL_DOMAIN =
  process.env.REACT_APP_PROTOCOL_DOMAIN ||
  process.env.NEXT_PUBLIC_PROTOCOL_DOMAIN ||
  (isOnServer ? '' : window.location.origin);

export const isAbsoluteURL = (url: any) => /^(?:[a-z]+:)?\/\//i.test(url.trim());

export const parseURL = (url: any) => {
  const parser = document.createElement('a');
  parser.href = url;
  const { href, protocol, host, hostname, port, origin, pathname, search, hash } = parser;

  return {
    ...(isAbsoluteURL(url) && {
      href,
      protocol,
      host,
      hostname,
      port,
      origin,
    }),
    pathname,
    search,
    hash,
  };
};
